<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    max-width="800"
  >
    <v-card>
      <v-card-title
        class="headline accent white--text"
      >
        Edit Label
      </v-card-title>
      <v-card-text>
        <v-textarea label="Label" v-model="label"></v-textarea>
        <v-switch label="Label Only" v-model="labelOnly"></v-switch>
        <v-text-field label="Font size" v-model="fontSize"  type="number" v-bind:rules="fontSizeRules"/>
        <v-input label="Font color" >
          <input v-model="color" type="color">
          <input v-model="color">
          <template v-slot:prepend>
            <v-icon v-bind:style="{ color: color }">fa-tint</v-icon>
          </template>
        </v-input>
        <v-input label="Background color" >
          <input v-model="backgroundColor" type="color">
          <input v-model="backgroundColor">
          <template v-slot:prepend>
            <v-icon v-bind:style="{ color: backgroundColor }">fa-tint</v-icon>
          </template>
        </v-input>
        <template v-if="!labelOnly">
          <equipment-selector v-model="equipment"></equipment-selector>
          <variable-selector :equipment="equipment" v-model="sensor" label="Variable"></variable-selector>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="dialog=false">
          <v-icon>fa-cancel</v-icon>
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          flat
          @click="saveStickie()"
        >
          <v-icon>fa-save</v-icon>
           Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EquipmentSelector from '../EquipmentSelector'
import VariableSelector from '../VariableSelector'

export default {

  name: 'EditStickie',
  props: {
    note: Object,
  },
  components: { VariableSelector, EquipmentSelector },
  computed: {

  },
  data () {
    return {
      labelOnly: false,
      dialog: false,
      label: '',
      fontSize: 14,
      color:'#000000',
      backgroundColor:'#ffffff',
      equipment: null,
      sensor: null,
      fontSizeRules: [v => v > 0 || 'Font size cannot be negative or null.']
     }
  },
  methods: {
    showEditor () {
      this.dialog = true
      this.label = this.note.label
      this.lableOnly = !this.note.equipment
      this.equipment = this.note.equipment
      this.sensor = this.note.sensor
      this.fontSize = this.note.fontSize ? this.note.fontSize : 14
      this.color = this.note.color ? this.note.color : '#000000'
      this.backgroundColor = this.note.backgroundColor ? this.note.backgroundColor : '#ffffff'
    },
    saveStickie: function () {
      this.currentContent = this.newContent
      this.currentURL = this.newURL
      this.currentBackgroundColor = this.newBackgroundColor
      this.currentComment = this.newComment
      this.currentAtBackground = this.newAtBackground
      this.updateStore()
      this.dialog = false
    },
    updateStore: function () {
      let note = this.note
      note.label = this.label
      note.equipment = this.equipment
      note.sensor = this.sensor
      note.color = this.color
      note.backgroundColor  = this.backgroundColor
      note.fontSize = this.fontSize
      this.$store.commit('editStickie', note)
    }
  }
}
</script>

<style scoped>

</style>
